import { render, staticRenderFns } from "./fade-in.vue?vue&type=template&id=e80561e2&"
import script from "./fade-in.vue?vue&type=script&lang=js&"
export * from "./fade-in.vue?vue&type=script&lang=js&"
import style0 from "./fade-in.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports